import { useEffect, useRef } from 'react'
import { ChatState, Message } from '../model/types'

interface UseChatStateProps {
  state: ChatState
  messages: Message[]
}

const LOG_STYLES = {
  prefix: [
    'background: hsl(0, 0%, 15%)',
    'color: hsl(228, 100%, 80%)',
    'font-weight: bold',
    'padding: 0 0.5em',
    'border: 1.6px solid hsl(228, 100%, 80%)',
    // 'text-shadow: 0 0 1px hsl(228, 100%, 80%)',
  ].join('; '),
  accent: [
    'background: hsl(0, 0%, 15%)',
    'color: rgb(255, 167, 239)',
    'padding: 0 0.25em',
    // 'text-shadow: 0 0 1px rgb(255, 167, 239)',
  ].join('; '),
  text: [
    'background: hsl(0, 0%, 15%)',
    'color: hsl(0, 0%, 100%)',
    'padding: 0 0.25em',
    // 'text-shadow: 0 0 1px hsl(0, 0%, 100%)',
  ].join('; '),
} as const

const logGigAss = (message: string, ...args: unknown[]): void => {
  console.log(`%cGIGASS %c${message}`, LOG_STYLES.prefix, LOG_STYLES.accent, ...args)
}

/**
 * @function useChatState
 * @description отслеживает изменения состояния чата и новые сообщения, выводя их в консоль
 * @param state - текущее состояние чата
 * @param messages - массив сообщений в чате
 */
export const useChatState = ({ state, messages }: UseChatStateProps) => {
  const prevStateRef = useRef<ChatState>(state)

  const handleStateChange = (newState: ChatState): void => {
    logGigAss(`состояние чата изменилось на: ${JSON.stringify(newState, null, 2)}`)
  }

  const handleNewMessage = (msg: Message): void => {
    logGigAss(`%s %s %c%s`, msg.isBot ? `🤖 бот` : `😊 юзер`, `|`, LOG_STYLES.text, msg.text)
  }

  useEffect(() => {
    if (prevStateRef.current !== state) {
      handleStateChange(state)
      prevStateRef.current = state
    }
  }, [state])

  useEffect(() => {
    const lastMessage = messages[messages.length - 1]
    if (lastMessage) {
      handleNewMessage(lastMessage)
    }
  }, [messages])
}
